export default {
      id: "recycle-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.svg#recycle",
      toString: function () {
        return this.url;
      }
    }